import { render, staticRenderFns } from "./certificationApply.vue?vue&type=template&id=8d0d9b92&"
import script from "./certificationApply.vue?vue&type=script&lang=js&"
export * from "./certificationApply.vue?vue&type=script&lang=js&"
import style0 from "./certificationApply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports